export default __webpack_public_path__ + "static/media/about.5a1d8681.png";